import React, { PureComponent } from 'react'
import { number, arrayOf, string } from 'prop-types'
import { Icon } from 'components'
import { range, flatten } from 'lodash'
import './BreadCrumb.css'

export class BreadCrumb extends PureComponent {
    static propTypes = {
        items: arrayOf(string),
        current: number
    }
    static defaultProps = {
        items: [],
        current: 1
    }

    componentWillMount() {
        this.refreshData(this.props)
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.items !== this.props.items) {
            this.refreshData(nextProps)
        }
    }

    refreshData = props => {
        const { items } = props
        this.itemWidth = 99.99 / items.length // percentage
        const gapHalfWidth = 0.75 // percentage
        const gapHalfHeight = 50 // percentage
        this.barClipPath = flatten([
            '0% 0%',
            ...range(1, items.length).map(i => i * this.itemWidth).map(gapCenter => [
                `${gapCenter - gapHalfWidth}% 0%`,
                `${gapCenter}% ${gapHalfHeight}%`,
                `${gapCenter - gapHalfWidth}% 100%`,
                `${gapCenter}% 100%`,
                `${gapCenter + gapHalfWidth}% ${gapHalfHeight}%`,
                `${gapCenter}% 0%`
            ]),
            '100% 0%',
            '100% 100%',
            '0% 100%'
        ])
        this.barClipPath = `polygon(${this.barClipPath.join(',')})`
    }

    renderItem = (index, text) => (
        <div key={index} className="BreadCrumb-Item" style={{ width: `${this.itemWidth}%` }}>
            {text}
        </div>
    )
    render() {
        const { items, current } = this.props
        const foregroundWidth = Math.min(current * this.itemWidth, 100)
        return (
            <div className="BreadCrumb">
                {items.map((text, index) => this.renderItem(index, text))}
                <div className="BreadCrumb-Bar-Wrapper">
                    <Icon name="breadcrumb-flag" style={{ right: `${100 - foregroundWidth}%`, opacity: current > 0 ? 1 : 0 }} />
                    <div className="BreadCrumb-Bar" style={{ clipPath: this.barClipPath }}>
                        <div style={{ width: `${foregroundWidth}%` }} />
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// src/components/StatusBar/BreadCrumb/BreadCrumb.js